import { Stack, TextField, styled } from "@mui/material";
import { useState, useEffect } from "react";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { usePortalContainer } from "@/common/hooks/use-portal-container";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

type SelectFilterValueProps = {
    options: any[];
    onSelectionChange?: (newValue: string) => void;
    valueField?: string;
};

const StyledExactDatePicker = styled(DesktopDatePicker)`
.MuiOutlinedInput-input {
    padding: 13px;
    font-size:14px;
}
.MuiInputBase-root {
    height: 36px;
}
`;

export const SelectFilterValue = ({ options, onSelectionChange, valueField, }: SelectFilterValueProps) => {
    const portalContainer = usePortalContainer();
    const initialValueField = !Array.isArray(valueField) && valueField && valueField.startsWith('exactDate') 
        ? valueField.replace('exactDate ', '') 
        : valueField;
        
    const [selectValue, setSelectValue] = useState<any>(initialValueField);
    const [exactDateIsChosen, setExactDateIsChosen] = useState<boolean>(false);
    const [exactDateValue, setExactDateValue] = useState<any>();

    const handleChange = (newValue: string) => {
        if (newValue === 'Exact Date') {
            setSelectValue('Exact Date');
            setExactDateIsChosen(true);
        } else {
            setExactDateIsChosen(false);
            setSelectValue(newValue);
            onSelectionChange?.(newValue);
        }
    };

    const exactDateHandleChange = (exactDateSelectValue: unknown) => {
        setExactDateIsChosen(true);
        setExactDateValue(exactDateSelectValue as string);
        onSelectionChange?.(`exactDate${exactDateSelectValue}`)
    }

    useEffect(() => {
        if (!Array.isArray(initialValueField) && initialValueField?.startsWith?.('exactDate')) {
            setExactDateIsChosen(true);
            setSelectValue('Exact Date');
            setExactDateValue(initialValueField.replace('exactDate ', ''))
        }
        else {
            setExactDateIsChosen(false);
            setExactDateValue(initialValueField)
        }
    }, [initialValueField])

    return (
        <Stack direction={'row'} gap={1} sx={{ width: '100%', alignItems: 'center' }}>
            <Select 
                value={exactDateIsChosen ? 'Exact Date' : selectValue} 
                onValueChange={handleChange}
            >
                <SelectTrigger 
                    className={cn(
                        "h-9 text-sm",
                        exactDateIsChosen ? "w-[120px]" : "w-full"
                    )}
                >
                    <SelectValue placeholder="Select..." />
                </SelectTrigger>
                <SelectContent container={portalContainer}>
                    {options.filter(opt => opt !== 'Blank').map((option, i) => (
                        <SelectItem key={i} value={option}>
                            {option}
                        </SelectItem>
                    ))}
                    <SelectItem value="Exact Date">Exact Date</SelectItem>
                </SelectContent>
            </Select>

            {exactDateIsChosen &&
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <StyledExactDatePicker
                        format="DD/MM/YY"
                        value={exactDateValue}
                        onChange={exactDateHandleChange}
                        slots={{ textField: (params: object) => <TextField {...params} /> }}
                        />
                </LocalizationProvider>
            }
        </Stack>
    );
};
